import { NgModule } from '@angular/core';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
@NgModule({
  declarations: [],
  imports: [

    NzLayoutModule,
    NzSelectModule,
    NzSpaceModule,
    NzCardModule,
    NzSpinModule,
    NzTableModule,
    NzDropDownModule,
    NzDescriptionsModule,
    NzDrawerModule,
    NzBadgeModule,
    NzIconModule,
    NzButtonModule,
    NzPageHeaderModule,
    NzAvatarModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzFormModule,
    NzInputModule,
    NzStatisticModule,
    NzDatePickerModule,
    NzMessageModule,
    NzTagModule,
    NzDividerModule,
    NzCollapseModule,
    NzModalModule,
    NzResultModule,
    NzSliderModule,
    NzInputNumberModule,
    NzListModule,
    NzCheckboxModule,
    NzRadioModule,
    NzStepsModule,
    NzTransferModule,
    NzSwitchModule,
    NzNotificationModule,
    NzEmptyModule,
    NzAffixModule,
    NzGridModule,
    NzSkeletonModule,
    NzTreeSelectModule,
    NzTimelineModule
  ],
  exports:[
    NzLayoutModule,
    NzSelectModule,
    NzSpaceModule,
    NzCardModule,
    NzSpinModule,
    NzTableModule,
    NzDropDownModule,
    NzDescriptionsModule,
    NzDrawerModule,
    NzBadgeModule,
    NzIconModule,
    NzButtonModule,
    NzPageHeaderModule,
    NzAvatarModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzFormModule,
    NzInputModule,
    NzStatisticModule,
    NzDatePickerModule,
    NzMessageModule,
    NzTagModule,
    NzDividerModule,
    NzCollapseModule,
    NzModalModule,
    NzResultModule,
    NzSliderModule,
    NzInputNumberModule,
    NzListModule,
    NzCheckboxModule,
    NzRadioModule,
    NzStepsModule,
    NzTransferModule,
    NzSwitchModule,
    NzNotificationModule,
    NzEmptyModule,
    NzAffixModule,
    NzGridModule,
    NzSkeletonModule,
    NzTreeSelectModule,
    NzTimelineModule
  ]
})
export class NzModule { }
